import type { ChipVariant } from '@/components/ui/Chip/Chip'
import { Chip } from '@/components/ui'
import type { IncidentStatus } from '../api/types'

const STATUS_LABELS: Record<IncidentStatus, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  reviewed: 'Reviewed',
}

const STATUS_VARIANTS: Record<IncidentStatus, ChipVariant> = {
  draft: 'neutral',
  submitted: 'warning',
  reviewed: 'success',
}

interface Props {
  status: IncidentStatus
}

export function IncidentStatusChip({ status }: Props) {
  return (
    <Chip variant={STATUS_VARIANTS[status] ?? 'default'}>
      {STATUS_LABELS[status] ?? status}
    </Chip>
  )
}
